import dbConnection from "../dbConnection";

const MLApi = {
  getMlModels: function () {
    return dbConnection.get("api/admin/ml");
  },
  getSingleMl: function (id) {
    return dbConnection.get("api/admin/ml/model/" + id);
  },
  trainMl: function (id) {
    return dbConnection.get("api/admin/ml/train/" + id);
  },
  previewData: function(payload){
    return dbConnection.post('api/admin/ml/previewData', payload);
  },
  previewPredict: function(payload){
    return dbConnection.post('api/admin/ml/previewPredict', payload);
  },
  applyModel: function(payload){
    return dbConnection.post('api/admin/ml/applyModel', payload);
  },
  saveMlModel: function (payload) {
    return dbConnection.post("api/admin/ml/store", payload);
  },
  train: function(id){
    return dbConnection.post("api/admin/ml/trainMlModel", { id: id });
  },
  getLogs: function (page, filterAutomationId) {
    if (!filterAutomationId) {
      filterAutomationId = 0;
    }
    return dbConnection.get(
      "api/admin/ml/logs/" + page + "/" + filterAutomationId
    );
  },
  deleteItem: function (id) {
    return dbConnection.delete("api/admin/ml/remove/" + id);
  },
  duplicateItem: function (id) {
    return dbConnection.get("api/admin/ml/duplicate/" + id);
  },
};

export default MLApi;
